import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EnterprisePageComponent} from './enterprise-page/enterprise-page.component';

const routes: Routes = [
  {
    path: '',
    component: EnterprisePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EnterpriseAreaRoutingModule {
}
